/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
import { Box, Grid, Typography, makeStyles } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CountUp from 'react-countup'
import Icon from '@mdi/react'
import { mdiCheckCircleOutline, mdiCreditCard } from '@mdi/js'

import colors from '../../../../assets/colors'
import BaseCreatePage from '../../../../components/hooks/BaseCreatePage'
import brandVisaPath from '../../../../../public/card_brands/visa_brand.png'
import brandMastercardPath from '../../../../../public/card_brands/mastercard_brand.png'
import { fetchClientSubscription } from '../../SubscriptionActions'
import SubscriptionAlertBanner from '../SubscriptionAlertBanner'
import StatusChip, { getPlanStatusTone } from '../Forms/StatusChip'
import { nextInvoiceReductionCents } from '../Forms/addonHelpers'

import AddonsAdmin from './AddonsAdmin'

// visão admin não age no pagamento — apenas informa o status ao operador
const ALERT_BY_STATUS = {
  10: {
    tone: 'info',
    message: 'Assinatura pendente: o cliente ainda não concluiu a contratação.',
  },
  30: {
    tone: 'error',
    message: 'Assinatura inadimplente: há fatura com falha de pagamento.',
  },
  40: {
    tone: 'error',
    message: 'Assinatura cancelada. O cliente está sem acesso ao sistema.',
  },
}

const useStyles = makeStyles({
  card: {
    border: '1px solid',
    borderColor: colors.graylight,
    padding: '20px 16px',
    borderRadius: '12px',
  },
  cardTitle: {
    fontSize: '20px',
    color: colors.primary,
    fontWeight: 'bold',
  },
  cardTile: {
    border: `1px solid ${colors.graylight}`,
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '10px 12px',
    marginBottom: '8px',
  },
  cardBrand: {
    width: '40px',
    height: '40px',
    borderRadius: '4px',
    border: `1px solid ${colors.graylight}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  emptyState: {
    color: colors.textPrimary,
    fontSize: '13px',
    padding: '12px',
    textAlign: 'center',
    border: `1px dashed ${colors.graylight}`,
    borderRadius: '10px',
  },
  sectionLabel: {
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    color: colors.textPrimary,
    marginBottom: '8px',
  },
})

const cardBrandPath = brand => {
  if (brand == 'visa') return brandVisaPath
  if (brand == 'mastercard') return brandMastercardPath
  return ''
}

const contUpMoney = money => (
  <CountUp
    end={money}
    duration={0.7}
    decimal=","
    decimals={2}
    prefix="R$"
    separator="."
  />
)

const Card = ({ title = '', children }) => {
  const classes = useStyles()

  return (
    <Box className={classes.card}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography className={classes.cardTitle}>{title}</Typography>
        </Grid>
        {children}
      </Grid>
    </Box>
  )
}

const PaymentInfo = () => {
  const classes = useStyles()
  const creditCards = useSelector(state => state.subscription.adminCreditCards)
  const paymentMethods = useSelector(
    state => state.subscription.adminPaymentMethods
  )
  const planDetails = useSelector(state => state.subscription.adminPlanDetails)

  const currentMethod = paymentMethods?.find(
    method => method?.var_id == planDetails?.payment_method_id
  )

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography className={classes.sectionLabel}>
          Método de pagamento
        </Typography>
        <Typography style={{ color: colors.textPrimary }}>
          {currentMethod?.value || planDetails?.payment_method || '—'}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography className={classes.sectionLabel}>
          Cartões cadastrados
        </Typography>
        {creditCards?.map(card => (
          <Box key={card?.id} className={classes.cardTile}>
            <Box className={classes.cardBrand}>
              {cardBrandPath(card?.brand) ? (
                <img
                  src={cardBrandPath(card?.brand)}
                  alt="Bandeira do cartão"
                  width="24px"
                  height="12px"
                  style={{ objectFit: 'contain' }}
                />
              ) : (
                <Icon path={mdiCreditCard} size={1} color={colors.primary} />
              )}
            </Box>
            <Box style={{ minWidth: 0 }}>
              <Typography
                style={{
                  fontSize: '14px',
                  fontWeight: 700,
                  textTransform: 'capitalize',
                  color: colors.textCustom,
                }}
                noWrap
              >
                {`${card?.brand} •••• ${card?.last_four_digits}`}
              </Typography>
              <Typography style={{ fontSize: '11px', color: colors.textGray }}>
                Expira em {card?.expiry}
              </Typography>
            </Box>
            {card?.id == planDetails?.card_id && (
              <Box style={{ marginLeft: 'auto' }}>
                <StatusChip label="Em uso" tone="success" />
              </Box>
            )}
          </Box>
        ))}

        {!creditCards?.length && (
          <Typography className={classes.emptyState}>
            Nenhum cartão cadastrado.
          </Typography>
        )}
      </Grid>
    </Grid>
  )
}

const PlanCard = () => {
  const classes = useStyles()
  const planDetails = useSelector(state => state.subscription.adminPlanDetails)
  const addons = useSelector(state => state.subscription.adminAddons)
  const laundryClientId = useSelector(
    state => state.subscription.adminLaundryClient?.id
  )

  // o total segue a quantidade de ACESSO dos add-ons (o que este ciclo já
  // pagou). Com redução de quantidade agendada, a próxima fatura vem menor.
  const reductionCents = nextInvoiceReductionCents(addons)
  const nextInvoice =
    planDetails?.total != null
      ? Math.max(0, Number(planDetails.total) - reductionCents / 100)
      : null

  if (!planDetails?.id) {
    return (
      <Box className={classes.card}>
        <Typography className={classes.emptyState}>
          Este cliente ainda não possui uma assinatura.
        </Typography>
      </Box>
    )
  }

  return (
    <Box className={classes.card}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '8px',
              flexWrap: 'wrap',
            }}
          >
            <Typography
              style={{
                fontWeight: 'bold',
                fontSize: '20px',
                color: colors.primary,
              }}
            >
              {planDetails?.name}
            </Typography>
            <StatusChip
              label={planDetails?.status?.value}
              tone={getPlanStatusTone(planDetails?.status?.var_id)}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
            <Typography
              style={{
                fontSize: '28px',
                color: colors.primary,
                fontWeight: 'bold',
              }}
            >
              {contUpMoney(planDetails?.total ?? planDetails?.price ?? 0)}
            </Typography>
            <Typography style={{ fontSize: '12px', color: colors.textGray }}>
              / mês
            </Typography>
          </Box>
          {planDetails?.total != null &&
            planDetails?.total !== planDetails?.price && (
              <Typography style={{ fontSize: '12px', color: colors.textGray }}>
                Plano base: {contUpMoney(planDetails?.price || 0)}
              </Typography>
            )}
          {reductionCents > 0 && nextInvoice != null && (
            <Typography style={{ fontSize: '12px', color: colors.textGray }}>
              Próxima fatura: {contUpMoney(nextInvoice)} — reflete as reduções e
              cancelamentos agendados nos serviços adicionais; o valor acima é o
              deste ciclo, já pago.
            </Typography>
          )}
        </Grid>

        {!!planDetails?.advantages?.length && (
          <Grid item xs={12}>
            <Grid container justifyContent="space-between" wrap="wrap">
              {planDetails.advantages.map((advantage, index) => (
                <Grid item xs={12} sm={6} key={`plan-advantage-${index}`}>
                  <Box style={{ display: 'flex', gap: '12px' }}>
                    <Icon
                      path={mdiCheckCircleOutline}
                      size={0.8}
                      color={colors.sucess}
                    />
                    <Typography style={{ color: colors.textGray }}>
                      {advantage?.label}: {advantage?.value}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        )}

        <Grid item xs={12}>
          <Box
            style={{
              borderBottom: '1px solid',
              borderColor: colors.graylight,
              width: '100%',
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <AddonsAdmin laundryClientId={laundryClientId} />
        </Grid>
      </Grid>
    </Box>
  )
}

const SubscriptionAdmin = props => {
  const dispatch = useDispatch()
  const laundryClientId = props.match.params.id

  const planDetails = useSelector(state => state.subscription.adminPlanDetails)
  const laundryClient = useSelector(
    state => state.subscription.adminLaundryClient
  )

  useEffect(() => {
    dispatch(fetchClientSubscription(laundryClientId))
  }, [laundryClientId])

  const alert = ALERT_BY_STATUS[planDetails?.status?.var_id]

  return (
    <BaseCreatePage
      page="Cliente Lavanderia"
      path={
        laundryClient?.name
          ? `Assinatura · ${laundryClient.name}`
          : 'Assinatura'
      }
      pageLink="laundry-clients"
    >
      <Grid container spacing={2}>
        {alert && (
          <Grid item xs={12}>
            <SubscriptionAlertBanner
              tone={alert.tone}
              message={alert.message}
            />
          </Grid>
        )}

        <Grid item md={6} sm={6} xs={12}>
          <PlanCard />
        </Grid>

        <Grid item md={6} sm={6} xs={12}>
          <Card title="Dados de pagamento">
            <Grid item xs={12}>
              <PaymentInfo />
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </BaseCreatePage>
  )
}

export default SubscriptionAdmin
